import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

// Translated by dacampsss

var ptBr = {
  language: 'pt-BR',
  country: 'br',
  name: 'Português',
  embeddedLocale: merge(error, login),
  flags: ['BR', 'PT'],
};

export { ptBr as default };
